import axiosClient from 'apis/axios-client';
import { AxiosResponse } from 'axios';

const GET_DISCOUNT_CONFIG_URL = '/admin/AdminDiscountManage/GetDiscountConfig';
const ADD_DISCOUNT_CONFIG_URL = '/admin/AdminDiscountManage/AddDiscountConfig';
const LOAD_CREDIT_PLAN_URL = '/admin/AdminDiscountManage/LoadCreditPlan';
const UPDATE_DISCOUNT_CONFIG_URL = '/admin/AdminDiscountManage/UpdateDiscountConfig';
const DELETE_DISCOUNT_CONFIG_URL = '/admin/AdminDiscountManage/DeleteDiscountConfig';

export const getDiscountConfig = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosClient.get(GET_DISCOUNT_CONFIG_URL);
    return response; // Return the entire response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error fetching discount config:', error.message);
    } else {
      console.error('Unknown error fetching discount config');
    }
    throw error;
  }
};

export const addDiscountConfig = async (creditPlanId: number, percentage: number): Promise<any> => {
  try {
    const payload = {
      creditPlanId,
      percentage,
    };

    const response: AxiosResponse<any> = await axiosClient.post(ADD_DISCOUNT_CONFIG_URL, payload);
    return response; // Return the entire response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error adding discount config:', error.message);
    } else {
      console.error('Unknown error adding discount config');
    }
    throw error;
  }
};

export const loadCreditPlan = async (): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosClient.get(LOAD_CREDIT_PLAN_URL);
    return response; // Return the entire response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error loading credit plan:', error.message);
    } else {
      console.error('Unknown error loading credit plan');
    }
    throw error;
  }
};


export const updateDiscountConfig = async (
  id: number,
  creditPlanId: number,
  percentage: number,
  isActive: boolean
): Promise<any> => {
  try {
    const payload = {
      id,
      creditPlaId: creditPlanId,
      percentage,
      isActive,
    };

    const response: AxiosResponse<any> = await axiosClient.post(UPDATE_DISCOUNT_CONFIG_URL, payload, {
      headers: {
        'accept': '*/*',
        'Content-Type': 'application/json',
      },
    });
    return response; // Return the entire response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error updating discount config:', error.message);
    } else {
      console.error('Unknown error updating discount config');
    }
    throw error;
  }
};

export const deleteDiscountConfig = async (id: number): Promise<any> => {
  try {
    const url = `${DELETE_DISCOUNT_CONFIG_URL}?id=${id}`;
    const response: AxiosResponse<any> = await axiosClient.delete(url);
    return response; // Return the entire response
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error deleting discount config:', error.message);
    } else {
      console.error('Unknown error deleting discount config');
    }
    throw error;
  }
};